import React from 'react'
import { css } from '@emotion/core'
import { useTranslation } from 'react-i18next'
import 'dayjs/locale/ja'
import 'react-dates/initialize'
import { Button } from '@/components/atoms/button'
import { DateRangeField } from '@/components/molecules/date-range-field'
import { EntireSearchContentType } from '@/models/entire-search'

type ContainerProps = {
  onClickReserch: () => void
  onClickClearReserch: () => void
  setIsDropDownReserchPanelOpen: (e?) => void
  detailedReserch: EntireSearchContentType
  setDetailedReserch: any
}

export const DetailedReserchPanel: React.FC<ContainerProps> = ({
  onClickReserch,
  onClickClearReserch,
  setIsDropDownReserchPanelOpen,
  detailedReserch,
  setDetailedReserch,
}) => {
  const { t } = useTranslation()

  // input change
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target
    setDetailedReserch({ ...detailedReserch, [name]: value })
  }

  // clear button
  const clearDetailedResearchPanelButton = () => {
    onClickClearReserch()
  }

  // 検索ボタン
  const searchDetailedReserchPanelButton = () => {
    onClickReserch()
    setIsDropDownReserchPanelOpen()
  }

  return (
    <div css={dropDownReserchPanelStyle}>
      <div css={topReserchPanelStyle}>
        <div css={fieldBlockStyle}>
          <div css={fieldTitleStyle}>{t('Full name')}</div>
          <input
            css={filedInputStyle}
            placeholder={`${t('John Doe')}`}
            name="name"
            value={detailedReserch.name}
            onChange={handleInputChange}
          ></input>
        </div>
        <div css={fieldBlockStyle}>
          <div css={fieldTitleStyle}>{t('Furigana')}</div>
          <input
            css={filedInputStyle}
            placeholder="ヤマダ　タロウ"
            name="nameKana"
            value={detailedReserch.nameKana}
            onChange={handleInputChange}
          ></input>
        </div>
        <div css={fieldBlockStyle}>
          <div css={fieldTitleStyle}>{t('Reservation ID')}</div>
          <input
            css={filedInputStyle}
            placeholder="12345678"
            name="searchReservationId"
            value={detailedReserch.searchReservationId}
            onChange={handleInputChange}
          ></input>
        </div>
        <div css={fieldBlockStyle}>
          <div css={fieldTitleStyle}>{t('Room number')}</div>
          <input
            css={filedInputStyle}
            placeholder="0101"
            name="roomNumber"
            value={detailedReserch.roomNumber}
            onChange={handleInputChange}
          ></input>
        </div>
      </div>
      <div css={middleReserchPanelStyle}>
        <div css={{ marginLeft: 21 }}>
          <div css={fieldTitleStyle}>{t('Check-out date')}</div>
          <div css={checkinTimeStyle}>
            <DateRangeField
              beginDate={detailedReserch.checkoutDateRange?.from}
              endDate={detailedReserch.checkoutDateRange?.to}
              changeRangeDate={(from: string, to: string) => {
                setDetailedReserch({ ...detailedReserch, checkoutDateRange: { from, to } })
              }}
            />
          </div>
        </div>
      </div>
      <div css={bottomReserchPanelStyle}>
        <div css={assignButtonContainerStyle}>
          <Button width={92} height={32} buttonType={3} fontSize={12} onClick={clearDetailedResearchPanelButton}>
            {t('Clear')}
          </Button>
          <Button width={93} height={32} buttonType={1} fontSize={12} marginLeft={16} onClick={searchDetailedReserchPanelButton}>
            {t('Search')}
          </Button>
        </div>
      </div>
    </div>
  )
}

const dropDownReserchPanelStyle = css({
  width: '91.8%',
  zIndex: 50,
  backgroundColor: '#FFF',
  position: 'absolute',
  top: 197,
  left: 72,
  boxShadow: '0px 3px 10px #0000003d',
  borderRadius: 5,
})

const topReserchPanelStyle = css({
  display: 'flex',
  marginTop: '32px',
  borderBottom: '1px solid rgb(242, 242, 242)',
  paddingBottom: '28px',
})

const middleReserchPanelStyle = css({
  display: 'flex',
  marginTop: '28px',
  borderBottom: '1px solid rgb(242, 242, 242)',
  paddingBottom: '28px',
})

const bottomReserchPanelStyle = css({
  display: 'flex',
  margin: 16,
})

const fieldBlockStyle = css({
  width: '22.5%',
  maxWidth: 240,
  marginLeft: 21,
})

const fieldTitleStyle = css({
  fontSize: 12,
  fontWeight: 'bold',
  marginBottom: '12px',
})

const filedInputStyle = css({
  width: '100%',
  height: 32,
  padding: '8px 16px',
  border: '1px solid #CCCCCC',
  borderRadius: 17,
  textAlign: 'left',
  backgroundSize: 10,
  '::placeholder': {
    color: '#CCCCCC',
  },
})

const assignButtonContainerStyle = css({
  display: 'flex',
  justifyContent: 'space-between',
})

const checkinTimeStyle = css({
  display: 'flex',
  alignItems: 'center',
  fontSize: 12,
  color: '#676767',
  fontWeight: 'bold',
  marginBottom: 23,
})
